import { z } from 'zod';

import { MetaTags } from '../models';
import { PTypes } from '../ptypes';

export const CmsPageResponse = z.object({
  metatags: z.optional(MetaTags),
  pageContent: z.array(PTypes),
});

export type CmsPageResponse = z.infer<typeof CmsPageResponse>;

export const CmsPageError = z.object({ message: z.string() });

export type CmsPageError = z.infer<typeof CmsPageError>;
